import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import InternationalBuyModal from '../../SellerInfo/InternationalBuyModal/InternationalBuyModal';
import { Modal } from '../../ui/Modal/Modal';
import { useInternationalShipping } from '../hooks/useInternationalShipping';
import { InternationalShippingStyles } from './style';

const InternationalShipping = ({ product, appCtx }) => {
  const hookData = useInternationalShipping({ product, appCtx });

  const { internationalDeliveryText, regionCode, deviceType, modalProps, toggleState, handleToggle, shouldRender } =
    hookData;

  if (!shouldRender) {
    return null;
  }

  const blockClass = 'international-shipping';
  const containerClasses = cx(blockClass);

  return (
    <div className={containerClasses}>
      <div className={`${blockClass}__icon-container`}>
        <span className={`${blockClass}__icon`} />
      </div>
      <div className={`${blockClass}__content`}>
        <div className={`${blockClass}__text`}>
          <span className={`${blockClass}__description`}>{internationalDeliveryText}</span>
          <button
            type="button"
            className={`${blockClass}__button`}
            onClick={handleToggle}
            aria-label="Conocer más sobre envío internacional"
          >
            Conocer más
          </button>
        </div>
      </div>
      <Modal
        content={(actions) => <InternationalBuyModal actions={actions} deviceType={deviceType} tenant={regionCode} />}
        toggleState={toggleState}
        {...modalProps}
      />
      <style jsx>{InternationalShippingStyles}</style>
    </div>
  );
};

InternationalShipping.propTypes = {
  product: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
};

export { InternationalShipping };
export default withApplicationContext(InternationalShipping);
